import { useApiData } from 'hooks/useApiData';
import { setLap } from 'store/lap/actions';

export const useMenuLapApi = (menuId: string, id: string) => {
    useApiData(`/laps/report/${id}/${menuId}`, setLap);
};
